import { render, staticRenderFns } from "./teamsModal.vue?vue&type=template&id=d113dcd2&"
import script from "./teamsModal.vue?vue&type=script&lang=js&"
export * from "./teamsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports